import { Component, ElementRef, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { Orders } from '../../../core/interfaces/orders';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../../core/services/localStorage/local-storage.service';
import { OrdersService } from '../../../core/services/orders/orders.service';
import { AlertService } from '../../../core/services/alert/alert.service';
import { AuthStateService } from '../../../core/services/auth-state/auth-state-service.service';
import { BadgeColorPipe } from '../../../core/pipe/badge-color.pipe';
import { BadgeVehiclePipe } from '../../../core/pipe/badge-vehicle.pipe';
import { BadgeClientPipe } from '../../../core/pipe/badge-client.pipe';

@Component({
  selector: 'app-order-table',
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule, MatTableModule,
    MatPaginatorModule, BadgeColorPipe, BadgeVehiclePipe, BadgeClientPipe],
  templateUrl: './order-table.component.html',
  styleUrl: './order-table.component.css'
})
export class OrderTableComponent {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('contenedor') contenedor!: ElementRef;
  @Input() typeOrders?: any; // Objeto opcional

  @Input() orderData?: any; // Objeto opcional
  @Input() searchParamsClickBar?: any; // Objeto opcional

  preTypeOrders: any = 'stages'; // Objeto opcional

  type: any = 'broker';
  displayedColumns: string[] = [];
  pageNumber: number = 1;
  pageSize: number = 25;
  sortColumn = 'stage_updated_at';
  sortDirection = 'asc';
  stage = '';
  showTable = false;

  dataSource = new MatTableDataSource<Orders>();
  title = 'orders';

  expandedRow: any = null;
  displayedColumnsBroker: string[] = [
    'broker_reference',
    'broker_agent',
    'supplier',
    'vendor',
    'client',
    'vehicle',
    'updated_at',
    'stage_updated_at',
    'stage',
    'actions',
  ];

  displayedColumnsSupplier: string[] = [
    'supplier_reference',
    'supplier_agent',
    'broker',
    'vendor',
    'client',
    'vehicle',
    'updated_at',
    'stage_updated_at',
    'stage',
    'actions',
  ];

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private orderService: OrdersService,
    private alertService: AlertService,
    private authStateService: AuthStateService
  ) {
    this.type = this.authStateService.getAccountType();
    this.displayedColumns =
      this.type === 'broker'
        ? this.displayedColumnsBroker
        : this.displayedColumnsSupplier;
  }
  @ViewChild('filterText') filterText!: ElementRef;
  ngOnChanges(changes: SimpleChanges) {
    if (changes['searchParamsClickBar'] && changes['searchParamsClickBar'].currentValue) {
      if (!changes['searchParamsClickBar'].isFirstChange()) {
        this.stage = this.searchParamsClickBar['stage[in]'];
        this.typeOrders = this.searchParamsClickBar['type'];
        Promise.all([
          this.fetchOrderData()
        ]).then(() => {
          setTimeout(() => {
            this.alertService.close();
            if (this.filterText && this.filterText.nativeElement) {
              this.filterText.nativeElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
              });
            }

          }, 500);
        });



      }
    }
  }


  fetchOrderData(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.alertService.loading('swal_messages.please_wait');
      this.orderService
        .getData(
          this.typeOrders,
          this.preTypeOrders,
          this.pageNumber,
          this.pageSize,
          this.searchParamsClickBar,
          this.sortColumn,
          this.sortDirection
        )
        .subscribe({
          next: (data) => {
            this.dataSource.data = data.data;
            this.dataSource.sort = this.sort;
            this.pageNumber = data.meta.current_page;
            if (!this.localStorageService.getItem('per_page')) {
              this.localStorageService.setItem('per_page', data.meta.per_page);
              this.pageSize = data.meta.per_page;
            } else {
              this.pageSize = Number(
                this.localStorageService.getItem('per_page')
              );
            }
            this.paginator.pageSizeOptions = [25, 50, 100];
            this.paginator.pageSize = this.pageSize;
            this.paginator.pageIndex = this.pageNumber - 1;
            this.paginator.length = data.meta.total;
            this.showTable = true;
            this.alertService.close();

            resolve();
          },
          error: (error) => {
            this.alertService.error(error.error);
            reject(error);
          },
        });
    });
  }


  toggleRow(row: any): void {
    const selection = window.getSelection();
    if (selection && selection.toString().trim().length > 0) return;
    this.expandedRow = row;
  }

  getDirection(): string {
    const directionMap: { [key: string]: string } = {
      asc: 'icon-arrow-up',
      desc: 'icon-arrow-down',
    };

    return directionMap[this.sortDirection] || 'icon-arrow-up';
  }


  onPageChange(event: PageEvent): void {
    this.pageNumber = event.pageIndex + 1;
    this.localStorageService.setItem('per_page', String(event.pageSize));
    this.pageSize = event.pageSize;
    this.fetchOrderData();

  }

  redirect(reference: string): void {
    this.router.navigate([`/orders/${reference}`]);
  }


}
